module.exports = __webpack_public_path__ + "img/soccerboard55.9cecf7be.jpg";